import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { GetEmployeeListBO } from './employee.model';


@Injectable({
    providedIn: 'root'
})
export class EmployeeListService extends Subject<DataStateChangeEventArgs> {
    constructor(private http: HttpClient, public errorService: ErrorService) {
        super();
    }
    public execute(EmpState: GetEmployeeListBO): void {
        this.getEmployeeFilter(EmpState).subscribe(x => super.next(x));
    }
    getEmployeeFilter(EmpState?: GetEmployeeListBO): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>("api/Employee/GetEmployees?", EmpState)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response['result'],
                        count: response['count']
                    }
            ))
    }
}

